import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('token'));

  useEffect(() => {
    const options = token
      ? { headers: { Authorization: `Bearer ${token}` }, credentials: 'omit' }
      : { credentials: 'include' };

    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, options)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => setUser(data.user))
      .catch(() => {
        setUser(null);
        localStorage.removeItem('token');
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const register = async (email, pass) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password: pass })
    });
    if (!res.ok) throw new Error('Error en registro');
    const { user } = await res.json();
    setUser(user);
    return user;
  };

  const login = async (email, pass) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password: pass })
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.message || 'Error en login');
    }
    const { user } = await res.json();
    setUser(user);
    return user;
  };

  const logout = async () => {
    await fetch(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    });
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, register, login, logout, setToken }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
